/* eslint-disable curly */
import React, { Component, useState, useRef, useEffect } from "react";
import {
  View,
  Text,
  ImageBackground,
  KeyboardAvoidingView,
  Platform,
  StatusBar,
  TextInput,
  TouchableOpacity,
  ScrollView,
} from "react-native";

import {
  enviarCodigoSMS,
  getStatusPorCpf,
} from "../../../services/aluno-service";
import ButtonConfirm from "../../../components/ButtonConfirm";
import Loading from "../../../components/Loading";
import styles from "./styles";
import { TextInputMask } from "react-native-masked-text";
import { api } from "../../../services/api";
import { setAluno } from "../../../services/auth-service";
import { alert } from "../../../utils/alerts";

const ResetSenhaCpf = ({ navigation }) => {
  const [codigo, setCodigo] = useState("");
  const [loading, setLoading] = useState(false);
  const [confirmDisabled, setConfirmDisabled] = useState(true);
  const [cronometro, setCronometro] = useState(0);
  const [getTime, setGetTime] = useState(null);
  const campoCodigo = useRef(null);
  const button = useRef(null);

  useEffect(() => {
    setCronometro(10);
    startClock();

    return () => {
      clearInterval(getTime);
    };
  }, []);

  const startClock = () => {
    const time = setInterval(() => {
      setCronometro((c) => {
        return c > 0 ? c - 1 : 0;
      });
    }, 1000);
    setGetTime(time);
  };

  useEffect(() => {
    if (cronometro == 0) {
      clearInterval(getTime);
    }
  }, [cronometro]);

  const handlerCodigo = async (e) => {
    setCodigo(e);
    if (!e.trim().match(/^[0-9]{6}$/i)) {
      setConfirmDisabled(true);
    } else {
      setConfirmDisabled(false);
    }
  };

  const handlerReenviarSMS = async (e) => {
    const { telefoneId, whatsapp } = navigation.state.params;

    let aluno = navigation.getParam("aluno");

    try {
      const retorno = await api.post(`/alunos/${aluno.cpf}/reset-senha`);

      setLoading(false);

      aluno = { ...aluno, ...retorno.data };

      setCronometro(119);
      startClock(); 
    } catch (e) {
      setLoading(false);
      if (e.response) {
        return alert("Erro", e.response.data.erro);
      }
      console.log(e);
      alert(
        "Erro",
        "Houve um erro no servidor, tente novamente mais tarde"
      );
    }
  };

  const enviar = async () => {
    setLoading(true);

    const { aluno } = navigation.state.params;

    try {
      const retorno = await api.post(`alunos/${aluno.cpf}/valida-reset-senha`, {
        codigo,
      });

      aluno.nome = retorno.data.nome;

      setAluno(aluno);

      navigation.replace("DefinirSenha");
    } catch (e) {
      setLoading(false);
      console.log(e);
      if (e.response) {
        return alert("Ops...", "Código inválido");
      }
      alert(
        "Ops...",
        "Houve um problema ao consultar, verifique o codigo e tente novamente"
      );
    }
  };

  const { aluno } = navigation.state.params;

  return (
    <>
      {loading && <Loading />}
      <KeyboardAvoidingView
        style={styles.container}
        behavior={Platform.OS === "ios" ? "padding" : "null"}
        enabled
      >
        <ImageBackground
          source={require("../../../../resources/imgs/bg.jpg")}
          style={styles.container}
          imageStyle={styles.imageContainer}
        >
          <View style={styles.containerForm}>
            <ScrollView>
              <Text style={styles.textHeader1}>
                Verifique seus SMS, enviamos um código para o número
              </Text>
              <Text style={[styles.textHeader1, { marginTop: 0 }]}>
                ({aluno.ddd + ") " + aluno.numero}
              </Text>

              <TextInput
                value={codigo}
                style={[styles.input, { letterSpacing: 10 }]}
                editable={!loading}
                placeholder="999999"
                maxLength={6}
                keyboardType="default"
                autoCapitalize="none"
                textContentType="oneTimeCode"
                autoFocus={true}
                placeholderTextColor="#CCC"
                onChangeText={handlerCodigo}
                onSubmitEditing={enviar}
              />
              <Text style={styles.textHeader2}>Não recebeu?</Text>
              <TouchableOpacity
                disabled={cronometro !== 0}
                onPress={handlerReenviarSMS}
              >
                <Text
                  style={[
                    styles.link,
                    {
                      marginTop: 5,
                      alignSelf: "center",
                      color: cronometro === 0 ? "#FFF" : "#BBB",
                    },
                  ]}
                >
                  Enviar novamente{cronometro !== 0 && ` em ${cronometro}s`}
                </Text>
              </TouchableOpacity>
            </ScrollView>
          </View>
          <ButtonConfirm
            text="Validar código"
            disabled={confirmDisabled}
            onPress={enviar}
            msgDisabled="Por favor, preencha com um código válido"
          />
        </ImageBackground>
      </KeyboardAvoidingView>
    </>
  );
};

export default ResetSenhaCpf;
